import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Clock, AlertTriangle, Lock } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { pluralN } from '../utils/plural';
import { formatDate } from '../utils/format';
import './BillingBanner.css';

/**
 * Плашка подписки в шапке (облако, 28.09): администратору склада — за 3 дня до конца
 * пробного/оплаченного срока, в «только просмотр» и когда склад закрыт. Данные —
 * /api/platform/plan → billing (backend/app/platform/subscription.state).
 * Индикатор ничего не делает сам — только ведёт на «Тариф и оплата».
 */
export default function BillingBanner() {
  const { plan } = useAuth();
  const { pathname } = useLocation();
  const b = plan && plan.billing;
  if (!b || b.phase === 'unlimited' || pathname.startsWith('/subscription')) return null;
  const left = b.days_left;
  let tone; let Icon; let text;
  if (b.phase === 'blocked') {
    tone = 'bad'; Icon = Lock; text = 'Склад закрыт: оплата не поступила. Данные сохранены.';
  } else if (b.phase === 'read_only') {
    tone = 'bad'; Icon = AlertTriangle;
    text = `Только просмотр: оплата не поступила. С ${formatDate(b.blocked_from)} склад закроется.`;
  } else if (left != null && left <= 3) {
    tone = 'warn'; Icon = Clock;
    const what = b.trial ? 'Пробный период' : 'Оплаченный период';
    text = left === 0 ? `${what} заканчивается сегодня.`
      : `${what} заканчивается через ${pluralN(left, ['день', 'дня', 'дней'])} (${formatDate(b.access_until)}).`;
  } else {
    return null;
  }
  return (
    <div className={`billing-banner billing-banner--${tone}`} role="status">
      <Icon size={18} aria-hidden="true" />
      <span className="billing-banner__text">{text}</span>
      <Link className="billing-banner__link" to="/subscription">{b.trial && b.phase !== 'blocked' && b.phase !== 'read_only' ? 'Выбрать тариф' : 'Оплатить'}</Link>
    </div>
  );
}
